import { Box, Typography } from '@mui/material';
import styles from './WithoutAnswerTag.styles';

type WithoutAnswerTagProps = {
  label: string;
};

const WithoutAnswerTag = function ({ label }: WithoutAnswerTagProps): JSX.Element {
  return (
    <Box sx={styles.container}>
      <Typography sx={styles.text}>{label}</Typography>
    </Box>
  );
};

export default WithoutAnswerTag;
